import {
    Component,
    OnInit,
    Input,
    Output,
    ViewChild,
    TemplateRef,
    EventEmitter
  } from "@angular/core";
  import { DatePipe } from "@angular/common";
  import { ToasterService } from "angular2-toaster";
  import * as _ from "lodash";
  import { GrnService } from '../../../services/grn.service';
  import { Store } from "@ngrx/store";
  import * as fromRootStore from "../../../reducers";
  
  import {
    PurchaseReportService
  } from "../../../services/index";
  
  @Component({
    selector: "fabricPrint",
    templateUrl: "./fabricPrint.html"
  })
  export class fabricPrint implements OnInit {
    @Input("tabTitle") title: string;
    @Input("tabID") tabID: string;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();
  
    isLoadMask: Promise<any>;
    barcode : string;
    design : string;
  
    loadingIndicator: boolean = true;
    gridOptions: any;
    StockDetails:any = [];
    data:any;
    design_no:any;
  
    page = {
      limit: 25,
      count: 10,
      offset: 0,
      orderBy: "po_no",
      orderDir: "desc"
    };
  
    @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
    @ViewChild('printTemplate') printTemplate: TemplateRef<any>;
    @ViewChild('partyDataTable') partyDataTable;
    columns = [];
    toggleCol = [];
  
    constructor(
      public store: Store<fromRootStore.State>,private grn: GrnService,
      private purService: PurchaseReportService,
      public toasterService: ToasterService,
      public datePipe: DatePipe,
    ) {
        this.barcode = '';
        this.design = '';
    }
  
    ngOnInit(): void {
        this.columns = [
            {name: 'SNo',prop: 'sno', minWidth: 80,maxWidth: 80,width: 80,headerClass:'text-center', sortable: false, cellTemplate: this.snoTemplate, toggle: true,cellClass: 'text-center', },
            {name: 'Barcode',prop: 'barcode',cellClass: 'text-center',headerClass:'text-center', minWidth: 100,maxWidth: 100,width: 100 },
            {name: 'Fab.Design',prop: 'fab_design',headerClass:'text-center',cellClass: 'text-center', minWidth: 120,maxWidth: 120,width: 120 },
            {name: 'Party.Design',prop: 'party_des',headerClass:'text-center', minWidth: 120,maxWidth: 120,width: 120 },
            {name: 'Color',prop: 'color',headerClass:'text-center',cellClass: 'text-right', minWidth: 100,maxWidth: 100,width: 100 },
            {name: 'Avl.Mtrs',prop: 'avl_mtrs',headerClass:'text-center', minWidth: 120,maxWidth: 120,width: 120 },
            { name: 'Action', prop: 'sno', headerClass:'text-center',minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.printTemplate },
        
        ];
  
  
      this.toggleCol = Object.assign({}, this.columns);
  
      this.pageCallback({ offset: 0 });
    }
  
  
    pageCallback(pageInfo: {
      count?: number;
      pageSize?: number;
      limit?: number;
      offset?: number;
    }) {
      this.page.offset = pageInfo.offset;
      this.getStockDetails();
    }



    loadGrn(row){
        
        let params = {
            barcode : row.barcode,
        };
        this.purService
            .getFabricPrint(params)
            .then((res: any) => {
                this.clickPrint(row,res.data);
                this.data.grnList = res.data;
                this.design_no = res.design_no - 1;
            });
    }
    
        clickPrint(row,data){
            let that = this;
            let params: any = Object.assign({}, row);
            params['data'] = JSON.stringify(data);
            that.isLoadMask = that.grn
                .grnprint(params)
                .then(function (res: any) {
                   
                }); 
        }
  
    getStockDetails(): void {
      let params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page:'1',
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        barcode : this.barcode,
        design : this.design
      };
  
      let that = this;
  
      this.isLoadMask = this.purService
        .fabricPrint(params)
        .then(function(res: any) {

            if(res.success){
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.StockDetails = res.data;
            }else{
                that.loadingIndicator = false;
            }
       
        });
    }
  
    ngOnDestroy() {
      this.purService;
      this.grn;
    }
  }
  


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/fabricPrint/fabricPrint.ts